const startAbortControllers: Map<string, AbortController> = new Map();

export const setStartAbortController = (
  engineName: string,
  controller: AbortController
) => {
  startAbortControllers.set(engineName, controller);
};

export const abortStartForEngine = (engineName: string) => {
  const controller = startAbortControllers.get(engineName);
  if (controller) {
    controller.abort();
    startAbortControllers.delete(engineName);
    return true;
  }
  return false;
};

export const clearStartAbortController = (
  engineName: string,
  controller: AbortController
) => {
  const existing = startAbortControllers.get(engineName);
  if (existing === controller) {
    startAbortControllers.delete(engineName);
  }
};
